import Defs from '../../../../includes/primitives/colorDefs'
export default {
  data: () => ({

    rawData:      null,
    nativeData:   null,
    dataSet:      null,

    canvasForms:  null,
    canvasTable:  null,

    title:        null,
    radio:        null,
    header:       null,
    depth:        null,
    columns:      null,

    current:      null,
    tDisplay:     null,
    tableHeight:  null,

    keys:         null,
    filters:      null,
  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {

    set_Gradients() {
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'LightGray',   [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Gray',        [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'DarkGray',    [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Yellow',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Gold',        [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Orange',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Pink',        [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Violet',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Red',         [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Thistle',     [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Purple',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'Indigo',      [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'LightBlue',   [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'SkyBlue',     [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'SteelBlue',   [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'YellowGreen', [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA2', 'DarkGreen',   [.5, 1, .5, -.5], this.localId)
    }, 

  }
}